const {
  getValue,
  getContentValues
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate getVariableBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const name = await evaluateSource(source.name, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof name !== 'string') {
    return undefined;
  }
  if (name.length > 0 && name.includes('*')) {
    return getContentValues(name, transientContext);
  }
  return name.length ? getValue(name, transientContext) : transientContext;
};
module.exports = {
  evaluate
};